const MapVariables: {
  [key: string]: string | {
    name: string,
    alpha?: number,
    darken?: number,
    brighten?: number
  }
} = {
  'config-anchor-base-color': 'config--main-color-brand',
  'config-anchor-base-hover-color': 'config--main-color-brand',
  'config-avatar-notification-background-color': 'config--main-color-brand',
  'config-button-cta-focus-background-color': {
    name: 'config-button-cta-background-color',
    darken: 2
  },
  'config-button-cta-focus-border-color': {
    name: 'config--main-color-brand',
    darken: 5
  },
  'config-button-cta-focus-border-width': 'config-button-cta-border-width',
  'config-button-cta-focus-color': 'config-button-cta-color',
  'config-button-cta-spinner-color': 'config--main-color-day-light',
  'config-button-cta-spinner-hover-color': 'config--main-color-day-light',
  'config-button-secondary-focus-background-color': {
    name: 'config--main-color-brand-secondary',
    darken: 5
  },
  'config-button-secondary-focus-border-color': {
    name: 'config--main-color-brand-secondary',
    darken: 5
  },
  'config-button-secondary-focus-border-width': 'config-button-secondary-border-width',
  'config-button-secondary-focus-color': 'config-button-secondary-color',
  'config-button-secondary-spinner-color': 'config--main-color-day-light',
  'config-button-secondary-spinner-hover-color': 'config--main-color-day-light',
  'config-button-toggle-filled-background-color': 'config--main-color-brand',
  'config-button-toggle-filled-color': 'config--main-color-day-light',
  'config-button-toggle-filled-pseudo-color': 'config--main-color-day-light',
  'config-button-toggle-filled-spinner-color': 'config--main-color-day-light',
  'config-button-toggle-focus-border-color': {
    name: 'config-button-toggle-outline-background-color',
    darken: 5
  },
  'config-button-toggle-outline-background-color': 'config--main-color-brand',
  'config-button-toggle-outline-color': 'config--main-color-brand',
  'config-button-toggle-outline-pseudo-color': 'config--main-color-brand',
  'config-button-toggle-outline-spinner-color': 'config--main-color-brand',
  'config-content-type-article-color': 'config--main-color-day-light',
  'config-create-topic-type-icon-color': 'config--main-color-night',
  'config-cta-close-button-color': 'config--main-color-dusk',
  'config-cta-icon-background-color': 'config--main-color-brand',
  'config-cta-icon-check': 'config--main-color-day-light',
  'config-editor-comment-toolbar-button-color': 'config--main-color-night',
  'config-editor-comment-toolbar-button-hover-color': 'config--main-color-brand',
  'config-footer-background-color': 'config--main-color-night',
  'config-footer-color': 'config--main-color-day-light',
  'config-hero-stats-background-color': 'config--main-color-day-light',
  'config-input-focus-color': 'config--main-color-brand',
  'config-link-base-color': 'config--main-color-night',
  'config-link-base-hover-color': 'config--main-color-brand',
  'config-mention-selector-hover-selected-color': 'config--main-color-day-light',
  'config-meta-link-hover-color': 'config--main-color-brand',
  'config-pagination-active-page-color': 'config--main-color-brand',
  'config-paging-item-hover-color': 'config--main-color-brand',
  'config-pill-color': 'config--main-color-day-light',
  'config-sidebar-widget-color': 'config-header-color',
  'config-sidebar-widget-font-family': 'config--main-font-base-stack',
  'config-sidebar-widget-font-weight': 'config--main-header-font-weight',
  'config-sidebar-widget-username-color': 'config-link-base-color',
  'config-tag-modify-link-color': 'config--main-color-brand',
  'config-tag-pill-hover-background-color': {
    name: 'config--main-color-brand',
    brighten: 55
  },
  'config-tag-pill-hover-border-color': 'config--main-color-brand',
  'config-tag-pill-hover-color': 'config--main-color-brand',
  'config-thread-list-best-answer-background-color': {
    name: 'config--main-color-success',
    brighten: 50
  },
  'config-thread-list-best-answer-border-color': 'config--main-color-success',
  'config-thread-list-mod-break-background': {
    name: 'config--main-color-brand',
    alpha: 0.95
  },
  'config-thread-list-mod-break-border-color': 'config--main-color-brand',
  'config-thread-list-sticky-topic-background': {
    name: 'config--main-color-brand',
    alpha: 0.95
  },
  'config-thread-list-sticky-topic-border-color': 'config--main-color-brand',
  'config-thread-list-sticky-topic-flag-color': 'config--main-color-brand',
  'config-thread-pill-answer-background-color': 'config--main-color-success',
  'config-thread-pill-author-background-color': 'config--main-color-brand',
  'config-thread-pill-author-color': 'config--main-color-day-light',
  'config-thread-pill-question-background-color': 'config-topic-question-color',
  'config-thread-pill-question-color': 'config--main-color-day-light',
  'config-thread-pill-sticky-background-color': 'config--main-color-brand',
  'config-thread-pill-sticky-color': 'config--main-color-day-light',
  'config-topic-page-answered-field-icon-color': 'config--main-color-success',
  'config-topic-page-answered-field-link-color': 'config--main-color-brand',
  'config-topic-page-post-actions-active': 'config--main-color-brand',
  'config-topic-page-post-actions-icon-color': 'config--main-color-dusk',
  'config-topic-page-quote-border-color': 'config--main-border-base-color',
  'config-username-hover-color': 'config--main-color-brand',
  'config-widget-tabs-font-weight': 'config--main-font-base-weight',
  'config-widget-tabs-forum-list-header-color': 'config-header-color',
  'config-widget-tabs-forum-list-header-hover-color': 'config--main-color-brand'
}

export default MapVariables
